import { Box, BoxProps } from '@mantine/core';

import cx from './CompanyLogoFallback.module.scss';

const CompanyLogoFallback = ({
    name,
    color,
    size = 'lg',
    ...props
}: { name: string; color?: string; size?: 'sm' | 'lg' } & BoxProps) => {
    return (
        <Box
            component="span"
            className={cx.root}
            style={{
                '--brand-color': color ?? 'var(--mantine-color-gray-5)',
            }}
            data-size={size}
            {...props}
        >
            <span className={cx.letter}>{name.charAt(0).toUpperCase()}</span>
        </Box>
    );
};

export { CompanyLogoFallback };
